import { OccasionPage } from "@/components/public/OccasionPage"
import labelGolf from "@/images/label-golf.webp"

const DESCRIPTION =
  "Club bottles, tournament prizes and charity-day wine with your crest on the label: custom wine gifts for sporting events, delivered throughout the UK."

export default function SportingEvents() {
  return (
    <OccasionPage
      title="Sporting Events"
      metaTitle="Branded Wine for Clubs & Sporting Events"
      description={DESCRIPTION}
      lede="Club bottles, tournament prizes and charity-day wine branded for your fixture."
      heroImage={{
        src: labelGolf,
        alt: "Bespoke golf club captains' day commemorative bottle",
        width: 941,
        height: 1672,
      }}
      story={{
        eyebrow: "Sporting Events",
        heading: "Branding that pays for itself",
        paragraphs: [
          "Club bottles, tournament prizes and captains' day gifts carry your crest to every table. Several of our clubs use a branded bottle as a fundraiser: buy it in at around £20 and sell it on the day for £30, with the difference going straight to the charity of the day.",
          "It works just as well as a straightforward prize or a thank-you to sponsors — the bottle is branded, the wine is good, and nothing about it looks like it came off a shelf.",
        ],
      }}
      cellar={{
        lede: "A small selection of bespoke bottles produced for clubs, schools and clubhouses across the United Kingdom.",
        bottles: [
          {
            src: labelGolf,
            alt: "Golf club captains' day commemorative bottle",
            name: "Captains' Day",
            place: "West Midlands",
          },
        ],
      }}
    />
  )
}
